export default __webpack_public_path__ + "static/media/logo_sq.f128076c.png";